import * as firebase from 'firebase/app';
import 'firebase/auth';
import firebaseConfig from './firebase-config';

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}
export const firebaseApp = firebase;
export const auth: firebase.auth.Auth = firebaseApp.auth();
